export enum MdrLiquidationTypeEnum {
  AUTOMATIC_SPLIT = 'AUTOMATIC_SPLIT',
}

export type MdrLiquidationType = keyof typeof MdrLiquidationTypeEnum
